import { Progress } from '@material-tailwind/react';
import TitleSection from 'components/common/TitleSection';
import { progressBarData } from 'helpers/aboutHelper';

const AboutVision = () => {
  const titleDetail = {
    upperTitle: '',
    middleTitle: 'DE EVENTE vision',
    lowerTitle: '“CREATING MEMORIES TO BE REMEMBERED AND CHERISHED FOREVER”',
  };
  return (
    <section className='relative z-10 DBlock py-12 px-6 md:px-10 bg-eventLightPink'>
      <img
        className='hidden sm:block absolute top-0 right-0 w-28 -z-10'
        src='/assets/images/about-us/vision.png'
        alt='visionImg'
      />
      <div className='max-w-7xl mx-auto'>
        <div className='DBlock'>
          <TitleSection titleDetail={titleDetail} />
        </div>
        <div className='DBlock'>
          <div className='max-w-6xl mx-auto place-items-start grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-16'>
            <div className=''>
              <img
                className='w-full'
                src='/assets/images/about-us/aboutVision.png'
                alt='aboutVision'
              />
            </div>
            <div className='DBlock'>
              <h1 className='lg:text-4xl sm:text-xl text-lg uppercase font-bold'>
                Client Satisfaction is Our Main Priority
              </h1>
              <p className='text-eventGray text-sm py-4 lg:text-base md:max-w-2xl font-light'>
                We deliver our promise by having teams of professional event
                planners and event designers who are trained to carry out
                seamless and fantastic events for your guests.
              </p>
              {progressBarData.map((list) => (
                <div
                  key={`progressList${list?.id}`}
                  className='flex items-center gap-4 md:px-4 pr-8 sm:justify-start justify-center'>
                  <div className='my-3 shadow-lg'>
                    <img src={list?.icon} alt='barImg' />
                  </div>
                  <div className='relative w-full'>
                    <Progress
                      className={`progBar${list?.id}`}
                      value={list?.value}
                      color={list?.fillColor}
                    />
                    <span className='capitalize text-sm pt-1'>
                      {list?.label}
                    </span>
                    <div className='absolute -right-10 -top-2.5 text-sm'>
                      {list?.value + '%'}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutVision;
